module.exports = {"350781001":"昭阳街道","350781002":"通泰街道","350781003":"水北街道","350781004":"晒口街道","350781100":"城郊镇","350781101":"水北镇","350781102":"下沙镇","350781103":"卫闽镇","350781104":"沿山镇","350781105":"拿口镇","350781106":"洪墩镇","350781107":"大埠岗镇","350781108":"和平镇","350781109":"肖家坊镇","350781110":"大竹镇","350781111":"吴家塘镇","350781200":"桂林乡","350781201":"张厝乡","350781202":"金坑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350781.json
// module id = 1339
// module chunks = 0